/**
 * Demo Mode API Endpoints
 * Endpoints for activating/managing demo mode with fictitious profiles
 */

import apiClient from '../client';

export interface DemoProfile {
  key: string;
  name: string;
  emoji: string;
  tagline: string;
  expected_savings: number;
}

interface ActivateDemoResponse {
  success: boolean;
  account: {
    id: number;
    name: string;
    transactions_count: number;
  };
  profile: DemoProfile;
}

interface DemoStatusResponse {
  // Global demo mode flag (like Stripe test mode)
  demo_mode: boolean;
  profile_name: string | null;
  // Legacy fields
  has_demo_data: boolean;
  demo_accounts: Array<{
    id: number;
    name: string;
    profile_name: string;
    transactions_count: number;
  }>;
  demo_transactions_count: number;
}

interface PurgeDemoResponse {
  success: boolean;
  message: string;
  transactions_purged: number;
}

export const demoApi = {
  /**
   * Get available demo profiles
   */
  getProfiles: async (): Promise<DemoProfile[]> => {
    const response = await apiClient.get('/demo/profiles');
    return response.data;
  },

  /**
   * Activate demo mode with a specific profile
   */
  activate: async (profileKey: string): Promise<ActivateDemoResponse> => {
    const response = await apiClient.post('/demo/activate', { profile_key: profileKey });
    return response.data;
  },

  /**
   * Get demo mode status
   */
  getStatus: async (): Promise<DemoStatusResponse> => {
    const response = await apiClient.get('/demo/status');
    return response.data;
  },

  /**
   * Purge all demo data
   */
  purge: async (): Promise<PurgeDemoResponse> => {
    const response = await apiClient.delete('/demo/purge');
    return response.data;
  },
};
